import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Button } from '../../../components/Button';
import messages from '../../messages';
import { HealthExpenseItem } from './HealthExpenseItem';

const emptyItem = () => ({
  id: new Date().getTime().toString(),
  selectedClaimFor: [],
  descriptionOfExpense: '',
  dateOfExpense: '',
  amountClaimed: '',
  amountClaimedCurrency: '',
  currency: 'CAD',
  providerName: '',
});

export class HealthExpenseList extends React.Component {
  componentDidMount() {
    const data = this.getData();
    if (data.length <= 0) {
      this.addItem();
    }
  }

  getData = () => {
    const { items } = this.props;
    return Array.isArray(items) ? items : [];
  };

  onRemove = (id) => {
    const arrayData = this.getData().filter((t) => t.id !== id);
    this.onChange(arrayData);
  };

  onItemChanged = (itemChanged) => {
    const data = this.getData();
    const item = data.filter((t) => t.id === itemChanged.id)[0];
    if (item) {
      const newData = data.map((el) =>
        el.id === itemChanged.id ? Object.assign({}, el, itemChanged) : el
      );
      this.onChange(newData);
    }
  };

  onChange = (data) => {
    const { onChange, itemsKey } = this.props;
    if (onChange && itemsKey) {
      onChange(itemsKey, data);
    }
  };

  addItem = () => {
    const arrayData = this.getData().slice();
    arrayData.push(emptyItem());
    this.onChange(arrayData);
  };

  render() {
    const data = this.getData();
    const { itemsKey, disabled, validatorGroup, validationCounter } = this.props;
    const removable = data.length > 1;

    return (
      <div>
        <div style={{ backgroundColor: '#d1d1d1' }}>
          {data.map((item, index) => (
            <HealthExpenseItem
              key={item.id}
              index={index}
              item={item}
              onChange={this.onItemChanged}
              onRemove={this.onRemove}
              disabled={disabled}
              removable={removable}
              validatorGroup={validatorGroup}
              validationCounter={validationCounter}
              insuredsList={this.props.insuredsList}
              intl={this.props.intl}
            />
          ))}
        </div>
        {!disabled && (
          <div className="ml-2 row">
            <div className="col-auto">
              <Button onClick={this.addItem}>
                <FormattedMessage {...messages.addExpense} />
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

HealthExpenseList.propTypes = {
  items: PropTypes.array,
  itemsKey: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  validatorGroup: PropTypes.object,
  validationCounter: PropTypes.number,
  insuredsList: PropTypes.array,
  intl: PropTypes.object,
};

export default HealthExpenseList;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.TripInterruption/components/HealthExpense/index.js